<template>
  <div class="col-sm-6 text-start">
    <div class="card">
      <div class="card-header pb-0">
        <h3>Vertical Scroll</h3>
      </div>
      <div class="card-body">
        <perfect-scrollbar class="vertical-scroll scroll-demo" v-once :settings="settings6">
          <div>
            <p v-for="item in data" :key="item">{{ item.desc }}</p>
          </div>
        </perfect-scrollbar>
      </div>
    </div>
  </div>
</template>
<script>
import scrollable from "@/data/scrollable.json"
export default {
  data() {
    return {
      settings6: {
        maxScrollbarLength: 60,
      },
      data: scrollable.verticalscroll
    }
  },
}
</script>
<style scoped>
.ps {
  height: 300px;
}
</style>